import React, { useEffect, useState } from "react";
import {
    ChevronLeft,
    ChevronRight,
    ArrowRight,
    MessageSquareText,
} from "lucide-react";

import i1 from "../Assets/Banner/1.jpg";
import i2 from "../Assets/Banner/2.png";
import i3 from "../Assets/Banner/Untitled-3a.jpg";

const BannerPages = () => {
    const slides = [
        {
            image: i1,
            smallTitle: "Performance Driven Marketing",
            title: "DIGITAL MARKETING AGENCY",
            subTitle: "SEO • SMO • Google Ads • Website Development",
            description:
                "Rank Higher on Google & Get More Organic Traffic Get Genuine Leads, More Sales & Better Business Growth",
            stats: [
                { number: "500+", label: "Campaigns" },
                { number: "10X", label: "Growth" },
                { number: "24/7", label: "Support" },
            ],
            tags: ["SEO OPTIMIZED", "SOCIAL MEDIA", "PAID ADS"],
            bottomText: "BRANDING · CONTENT · MARKETING · STRATEGY",
        },

        {
            image: i2,
            smallTitle: "Creative Brand Solutions",
            title: "Increase Visibility, Reach & Revenue",
            subTitle: "Website • SEO • Ads • Social Media",
            description:
                "Turn Clicks Into Customers with Creative Campaigns & Measurable Results.",
            stats: [
                { number: "100+", label: "Brands" },
                { number: "1M+", label: "Reach" },
                { number: "99%", label: "Satisfaction" },
            ],
            tags: ["CONTENT CREATION", "VIDEO MARKETING", "BRAND DESIGN"],
            bottomText: "CREATIVE · ENGAGING · MODERN · PROFESSIONAL",
        },
    ];

    const [currentSlide, setCurrentSlide] = useState(0);

    // Auto Slide
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [currentSlide]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) =>
            prev === 0 ? slides.length - 1 : prev - 1
        );
    };

    return (
        <section className="relative w-full h-screen overflow-hidden bg-black mt-[10%]">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center transition-all duration-1000 scale-105 "
                style={{
                    backgroundImage: `url(${slides[currentSlide].image})`,
                }}
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#120b07]/95 via-[#24150f]/75 to-transparent" />

            {/* Main Content */}
            <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24">
                <div className="max-w-5xl w-full animate-fadeIn">
                    {/* Small Title */}
                    <div className="flex items-center gap-4 mb-5">
                        <div className="w-10 h-[2px] bg-[#d6b45f]" />

                        <p className="text-[#d6b45f] uppercase tracking-[4px] text-[11px] sm:text-sm font-semibold">
                            {slides[currentSlide].smallTitle}
                        </p>
                    </div>

                    {/* Main Heading */}
                    <h1
                        className="
              text-white
              font-serif
              font-bold
              leading-tight
              text-xl
              sm:text-2xl
              md:text-3xl
              lg:text-4xl
              xl:text-[48px]
              max-w-5xl
            "
                    >
                        {slides[currentSlide].title}
                    </h1>

                    {/* Subtitle */}
                    <p className="mt-6 text-[#d6b45f] uppercase tracking-[3px] text-xs">
                        {slides[currentSlide].subTitle}
                    </p>

                    {/* Tags */}
                    <div className="flex flex-wrap gap-4 mt-8">
                        {slides[currentSlide].tags.map((item, index) => (
                            <button
                                key={index}
                                className="
                  border border-[#c8a34d]
                  text-[#d6b45f]
                  rounded-full
                  px-5 py-3
                  text-sm
                  tracking-[2px]
                  hover:bg-[#d6b45f]
                  hover:text-black
                  transition-all duration-300
                "
                            >
                                {item}
                            </button>
                        ))}
                    </div>

                    {/* Description */}
                    <p
                        className="
              mt-10
              text-gray-300
              leading-[2]
              text-sm
              sm:text-base
              md:text-lg
              max-w-3xl
            "
                    >
                        {slides[currentSlide].description}
                    </p>

                    {/* Stats */}
                    <div className="flex flex-wrap gap-8 md:gap-12 mt-14">
                        {slides[currentSlide].stats.map((stat, index) => (
                            <React.Fragment key={index}>
                                <div>
                                    <h2 className="text-white font-serif text-4xl sm:text-5xl">
                                        {stat.number}
                                    </h2>

                                    <p className="text-[#d6b45f] tracking-[3px] text-sm mt-2 uppercase">
                                        {stat.label}
                                    </p>
                                </div>

                                {index !== slides[currentSlide].stats.length - 1 && (
                                    <div className="hidden md:block w-[1px] bg-[#8c6b34] h-20" />
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    {/* Buttons */}
                    <div className="flex flex-wrap gap-5 mt-14">
                        <a
                            href="mailto:info@growthloomdigital.com"
                            className="
    bg-[#d6b45f]
    text-black
    rounded-full
    px-8 sm:px-10
    py-4
    inline-flex items-center gap-3
    font-semibold
    tracking-[2px]
    text-sm
    hover:scale-105
    transition-all duration-300
  "
                        >
                            Enquire Now
                            <ArrowRight size={20} />
                        </a>
                        {/* <button
                            className="
                bg-[#d6b45f]
                text-black
                rounded-full
                px-8 sm:px-10
                py-4
                flex items-center gap-3
                font-semibold
                tracking-[2px]
                text-sm
                hover:scale-105
                transition-all duration-300
              "
                        >
                             Enquire Now
                            <ArrowRight size={20} />
                        </button> */}

                        {/* <button
                            className="
                border border-[#8c6b34]
                text-white
                rounded-full
                px-8 sm:px-10
                py-4
                tracking-[2px]
                text-sm
                hover:bg-white
                hover:text-black
                transition-all duration-300
              "
                        >
                            QUALITY STANDARDS
                        </button> */}
                    </div>
                </div>
            </div>

            {/* Left Button */}
            <button
                onClick={prevSlide}
                className="
          absolute
          left-4
          md:left-8
          bottom-24
          w-12 h-12
          md:w-14 md:h-14
          rounded-full
          border border-[#8c6b34]
          text-white
          flex items-center justify-center
          bg-[#2a1b13]/60
          backdrop-blur-md
          hover:bg-[#d6b45f]
          hover:text-black
          transition-all duration-300
          z-20
        "
            >
                <ChevronLeft size={28} />
            </button>

            {/* Right Button */}
            <button
                onClick={nextSlide}
                className="
          absolute
          right-4
          md:right-8
          bottom-24
          w-12 h-12
          md:w-14 md:h-14
          rounded-full
          border border-[#8c6b34]
          text-white
          flex items-center justify-center
          bg-[#2a1b13]/60
          backdrop-blur-md
          hover:bg-[#d6b45f]
          hover:text-black
          transition-all duration-300
          z-20
        "
            >
                <ChevronRight size={28} />
            </button>

            {/* Bottom Badge */}
            <div
                className="
          absolute
          bottom-8
          right-24
          hidden lg:flex
          items-center
          bg-[#2a1b13]/80
          border border-[#8c6b34]
          rounded-full
          px-8 py-4
          backdrop-blur-md
          z-20
        "
            >
                <p className="text-[#d6b45f] tracking-[3px] text-sm uppercase">
                    {slides[currentSlide].bottomText}
                </p>
            </div>

            {/* Chat Button */}
            <button
                className="
          absolute
          bottom-6
          right-6
          w-16 h-16
          md:w-20 md:h-20
          rounded-full
          bg-[#5e0d0d]
          shadow-2xl
          flex items-center justify-center
          hover:scale-110
          transition-all duration-300
          z-20
        "
            >
                <MessageSquareText
                    size={30}
                    className="text-white"
                />
            </button>

            {/* Dots */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-20">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`
              rounded-full transition-all duration-300
              ${currentSlide === index
                                ? "w-10 h-3 bg-[#d6b45f]"
                                : "w-3 h-3 bg-white/50"
                            }
            `}
                    />
                ))}
            </div>
        </section>
    );
};

export default BannerPages;